// // MODIFIED: Logic decoupling to prevent auto-submission
import React, { useRef, useState } from "react";
import { Input, TextArea } from "../../../../common/Input";
import { Select } from "../../../../common/Select";
import { Button, GeneralMessage } from "../../../../common/APICommon";
import { ConfirmationModal, ImageViewModal, PDFModal } from "../../../../common/Modal";

const ChangeScheduleModule = ({
  user, shiftSchedules, formData, handleInputChange, handleFileChange,
  submitRequest, showMessage, message, isSuccess, loading
}) => {
  const fileInputRef = useRef(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [errorState, setErrorState] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  // // STEP 1: Validation only. Sets the Modal to Open.
  const onFormSubmit = (e) => {
    if (e) e.preventDefault(); // // ADDED: Critical to stop native HTML submission

    if (!formData.dateFrom || !formData.dateTo || !formData.shiftScheduleFromId || !formData.shiftScheduleToId || !formData.reason) {
      setErrorState(true);
      return;
    }
    setErrorState(false);
    setIsConfirmOpen(true); // // ONLY opens the modal
  };

  // // STEP 2: The actual trigger for the API
  const handleFinalConfirm = async () => {
    const success = await submitRequest();
    if (success) {
      setIsConfirmOpen(false);
    }
  };

  const getFileUrl = () => {
    if (!formData.content) return "";
    return `data:${formData.fileType};base64,${formData.content}`;
  };

  const handleDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); setIsDragging(false); };
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileChange(e.dataTransfer.files[0]);
    }
  };

  return (
    <>
      <div className="space-y-6 p-4">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
          {/* // form action handled by onFormSubmit wrapper */}
          <form onSubmit={onFormSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <Input label="Employee Name" type="text" value={user.employeePersonalInformationFullName} isDisabled={true} />
              <div className="grid grid-cols-2 gap-4">
                <Input label="Date From" type="date" value={formData.dateFrom} onChange={(e) => handleInputChange('dateFrom', e.target.value)} isRequired error={errorState && !formData.dateFrom} />
                <Input label="Date To" type="date" value={formData.dateTo} onChange={(e) => handleInputChange('dateTo', e.target.value)} isRequired error={errorState && !formData.dateTo} />
              </div>
              <Select label="Shift Schedule From" value={formData.shiftScheduleFromId} onChange={(e) => handleInputChange('shiftScheduleFromId', e.target.value)} options={shiftSchedules} isRequired error={errorState && !formData.shiftScheduleFromId} />
              <Select label="Shift Schedule To" value={formData.shiftScheduleToId} onChange={(e) => handleInputChange('shiftScheduleToId', e.target.value)} options={shiftSchedules} isRequired error={errorState && !formData.shiftScheduleToId} />
            </div>

            <div className="flex flex-col space-y-4">
              <TextArea label="Reason" placeholder="Enter your reason here..." isRequired value={formData.reason} onChange={(e) => handleInputChange('reason', e.target.value)} error={errorState && !formData.reason} rows={6} />
              <div
                className={`border-2 border-dashed rounded-lg p-4 text-center flex-grow flex flex-col justify-center transition-colors ${isDragging ? "border-blue-500 bg-blue-50" : "border-gray-300 bg-gray-50"}`}
                onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}
              >
                <input type="file" ref={fileInputRef} className="hidden" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => handleFileChange(e.target.files[0])} />
                <p className="text-xs text-gray-500 mb-2">{formData.fileName ? <span className="text-blue-600 font-bold">Selected: {formData.fileName}</span> : "Drag & drop or Click to upload (Max 5MB)"}</p>
                <div className="flex justify-center gap-2">
                  <Button name="Upload File" className="bg-gray-500 text-white text-xs" onClick={() => fileInputRef.current.click()} />
                  {formData.content && <Button name="Preview" className="bg-blue-500 text-white text-xs" onClick={() => setIsPreviewOpen(true)} />}
                </div>
              </div>
            </div>

            <div className="md:col-span-2 flex justify-end">
              <Button name="Send Request" className="bg-blue-600 text-white px-8 py-2.5 font-bold" type="submit" />
            </div>
          </form>
        </div>
      </div>

      {formData.fileType === "application/pdf" ? (
        <PDFModal visible={isPreviewOpen} onClose={() => setIsPreviewOpen(false)} fileUrl={getFileUrl()} />
      ) : (
        <ImageViewModal isOpen={isPreviewOpen} onClose={() => setIsPreviewOpen(false)} fileData={formData.content} fileType={formData.fileType || "image/jpeg"} />
      )}

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />

      <ConfirmationModal
        visible={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleFinalConfirm} // // MODIFIED: Point to guard function
        title="Confirm Change Schedule Submission"
        message={`Confirm request for ${formData.dateFrom} to ${formData.dateTo}?`}
        isLoading={loading}
      />
    </>
  );
};

export default ChangeScheduleModule;